__turbopack_context__.v({
  "auth": "Auth-module__ExML1a__auth",
  "errorBlock": "Auth-module__ExML1a__errorBlock",
  "subtitle": "Auth-module__ExML1a__subtitle",
  "title": "Auth-module__ExML1a__title",
  "titleDescription": "Auth-module__ExML1a__titleDescription",
});
